export default __webpack_public_path__ + "e3707fd716dd520475fdc5cb2b4d5024.png";